<div class="mood-calendar-container">
  <!-- Header with Title and Month/Year Selector -->
  <div class="calendar-header">
    <h3 class="calendar-title">Mood Checkins & Energy Levels</h3>
    <div class="month-year-selector">
      <mat-form-field appearance="outline" class="month-select">
        <mat-label>Month</mat-label>
        <mat-select [(ngModel)]="selectedMonth" (selectionChange)="onMonthYearChange()">
          <mat-option *ngFor="let month of months; let i = index" [value]="i" [disabled]="isMonthDisabled(i)">
            {{ month }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="year-select">
        <mat-label>Year</mat-label>
        <mat-select [(ngModel)]="selectedYear" (selectionChange)="onMonthYearChange()">
          <mat-option *ngFor="let year of years" [value]="year" [disabled]="isYearDisabled(year)">
            {{ year }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <!-- Month and Year Display -->
  <div class="month-year-display">
    <h4>{{ months[selectedMonth] }}, {{ selectedYear }}</h4>
  </div>

  <!-- Calendar Grid -->
  <div class="calendar-grid" *ngIf="!isLoading">
    <!-- Day Headers -->
    <div class="calendar-day-header">
      <div class="day-header-cell" *ngFor="let dayName of ['SUN', 'MON', 'TUE', 'WED', 'THUR', 'FRI', 'SAT']">
        {{ dayName }}
      </div>
    </div>

    <!-- Calendar Days -->
    <div class="calendar-days">
      <div 
        class="calendar-day-cell" 
        *ngFor="let day of calendarDays"
        [class.empty-day]="!day.isCurrentMonth"
        [class.has-entries]="day.isCurrentMonth && day.entries > 0"
        (click)="onDayClick(day)">
        <div *ngIf="day.isCurrentMonth" class="day-content">
          <div class="day-date">{{ months[selectedMonth].substring(0, 3) }} {{ day.day }}</div>
          <div class="day-mood">
            <img 
              *ngFor="let emoji of day.emojis" 
              [src]="emoji" 
              [alt]="emoji" 
              class="mood-emoji"
            />
          </div>
          <div class="day-entries" *ngIf="day.entries > 0">
            <span>{{ day.entries }} Entries</span>
            <span class="arrow-icon">></span>
          </div>
          <div class="day-entries" *ngIf="day.entries === 0">
            <span>0 Entries</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading Indicator -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner diameter="50"></mat-spinner>
    <p>Loading mood checkin data...</p>
  </div>
</div>

